// src/app/core/chatPage/chatComponents/components/WelcomeBanner.tsx
import { MessageSquare } from "lucide-react";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface WelcomeBannerProps {
  activeConversationTitle?: string | null;
  onExampleClick?: (prompt: string) => void;
}

export function WelcomeBanner({ activeConversationTitle, onExampleClick }: WelcomeBannerProps) {
  const { t } = useTranslation();

  const title =
    activeConversationTitle ||
    (t('welcomeTitle') as string) ||
    'Чем помочь сегодня?';

  const description =
    activeConversationTitle
      ? (t('welcomeHistoryMessage') as string) || 'Продолжите диалог или начните новый.'
      : (t('welcomeDescription') as string) || 'Задайте вопрос, попросите текст, картинку или видео.';

  const examples = [
    (t('example1') as string) || 'Придумай идею для поста',
    (t('example2') as string) || 'Опиши картинку про космос',
    (t('example3') as string) || 'Сделай короткое резюме текста',
  ];

  return (
    <div className="p-6 mt-2 bg-white/20 dark:bg-white/10 backdrop-blur-md rounded-3xl border border-white/30 dark:border-white/20 shadow-lg flex flex-col gap-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-accent/20 backdrop-blur-sm border border-accent/30 flex items-center justify-center shadow-lg shadow-accent/25">
          <MessageSquare className="w-6 h-6 text-accent" />
        </div>
        <div>
          <h3 className="text-2xl font-bold text-foreground">{title}</h3>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{description}</p>
        </div>
      </div>

      {onExampleClick && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {examples.map((prompt) => (
            <button
              key={prompt}
              onClick={() => onExampleClick(prompt)}
              className="p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 text-sm text-left text-foreground hover:bg-white/20 dark:hover:bg-white/20 transition-colors"
            >
              {prompt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}